import { Badge, Box, Link } from "@mui/material"
import { useEffect } from "react"
import { useTransactionsAndFaos } from "../../../Context/crm/TransactionsAndFaosContext"
import CustomBtn from "../../customBtns/CustomBtn"
import BiotechOutlinedIcon from '@mui/icons-material/BiotechOutlined';


const EnquetesBadge = ({onClick}) => {
    const {faos} = useTransactionsAndFaos()

    useEffect(() => {
        console.log('faos in faos badge : ', faos)
    })
    return (
        <Box sx={{marginRight: "15px"}}>
            <Link to="#enquete" onClick={onClick} sx={{cursor: "pointer" , marginInline: {xl : 0 , lg: 0 , md: 0 , sm: 0 ,xs:1}}}>
            <Badge
                sx={{
                    "& .MuiBadge-badge": {
                        background: "#CEDEF2",
                        color: "#000000",
                    }
                }}
                badgeContent={
                faos.length > 0 ? faos.length : '0'}
                   size="small"
                   anchorOrigin={{  vertical: 'top', horizontal: 'left', }}>
            <CustomBtn
                          bgColor={"#CEDEF2"}
                          label="Enquêtes"
                          textColor={"#000000"}
                          iconBg={"#CEDEF2"}
                          style={{
                              transition: 'background-color 0.4s ease, color 0.4s ease',
                              '&:hover': {
                                  backgroundColor: '#000000 !important',
                                  color: '#ffffff !important',
                              },
                              '&:hover .MuiChip-label': {
                                  color: '#ffffff',
                              },
                              '&:hover .MuiAvatar-root': {
                                  backgroundColor: '#000000 !important',
                              },
                              '&:hover svg': {
                                  color: '#ffffff !important',
                              }
                          }}
                          icon={<BiotechOutlinedIcon sx={{ fontSize: "18px", color:"#000000" }} />}
                      />
            </Badge>
            </Link>

        </Box>
    )
}

export default EnquetesBadge